import React, { Component } from 'react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { MessageBars } from '../Outils/MessageBars';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { DetailsList, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { DataReservation } from '../../data/DataReservation';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    reservation
    listeDesTVAs
    peutModifierBlocPrix

    onAffichePanelTarifReservation : bool
    onAffichageSansPanel: bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
    onChange : méthode appelée si onAffichageSansPanel = true
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

let precision = 12;
let precisionMessageErreur = 12;

var objetState = {
    reservation: {},
    prixTTC: 0,
    //idCasTVASelectionnee: 0,

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    titrePanelTarifReservation: 'Renseigner les tarifs de la réservation',
};

export class FicheTarifReservation extends Component {
    /*YD : 04/06/2020
    supp disabled={this.state.reservation.estValidee} et ajout disabled={!this.state.peutModifierBlocPrix} sur TextField 'Prix réservation HT', 'Prix réservation TTC'

    YD : 24/06/2020
     supp Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'reservation', 'prixHT', false, 2)} dans value du TextField Prix HT
     et remplacement par Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(this.state.reservation.prixHT.toFixed(2), false, 2)
      (this.state.reservation.prixHT !== undefined && this.state.reservation.prixHT != null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(this.state.reservation.prixHT.toFixed(2), false, 2) : null)}
     */

    _creationContent() {
        // preuve d'une réservation renseignée : https://jsbin.com/ceyexibuxa/edit?html,js,console,output
        const enModeCreation = !this.props.idReservation && this.props.idReservation <= 0;
        const champsActifs = enModeCreation ? true : this.props.peutModifierBlocPrix;

        const prixHTValue = Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'reservation', 'prixHT', false, precision, 2);
        const prixTTCValue = Scriba.officeUI().textField().nombre().ValeurChampNombreAvecPrecisionAfficheeSpecifiee(this, 'prixTTC', false, precision, 2);
        const prixTTCValue_formatstring = (this.state.prixTTC != null ? this.state.prixTTC.toString() : '0');


        return (
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Prix réservation HT"
                                required
                                disabled={!champsActifs}
                                value={prixHTValue}
                                onFocus={() => this._onFocusPrixHT()}
                                onBlur={e => this._onBlurPrixHT(e.target.value)}
                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'prixHT', e, false, precisionMessageErreur)}
                                deferredValidationTime={0}
                                suffix="€"
                                tabIndex="1"
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            Taux TVA : {Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee((this.state.reservation.tauxTVA * 100).toFixed(2), false, 2)} %
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            Montant TVA : {(this.state.reservation.prixHT !== undefined && this.state.reservation.prixHT != null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee((this.state.reservation.prixHT * this.state.reservation.tauxTVA).toFixed(2), false, 2) : null)} €
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Prix réservation TTC"
                                required
                                disabled={!champsActifs}
                                value={prixTTCValue}
                                onFocus={() => this._onFocusPrixTTC()}
                                onBlur={e => this._onBlurPrixTTC(e.target.value)}
                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'prixTTC', e, false, precisionMessageErreur)}
                                deferredValidationTime={0}
                                suffix="€"
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 labelEnToutesLettres">
                            En toutes lettres : <span>{Immocom.conversion().nombreEnToutesLettres(prixTTCValue_formatstring)}</span>
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            Prix maitrisé : {Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee((this.state.reservation.prixMaitriseHT), false, 2)} €
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            Type prix maitrisé : {this.state.reservation.prixMaitrise}
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <Toggle
                                name="fraisNotaire"
                                label="Frais de notaire offerts"
                                defaultChecked={false}
                                onText="Oui"
                                offText="Non"
                                checked={this.state.reservation.fraisNotaireOffert}
                                onChange={(e, isChecked) => this._onChangeFraisNotaireOffert(isChecked)}
                                tabIndex="2"
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                name="montantNotaire"
                                //disabled={!this.state.reservation.fraisNotaireOffert}
                                label="Montant frais de notaire"
                                value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'reservation', 'montantFraisNotaire', false, 2)}
                                onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'reservation', 'montantFraisNotaire')}
                                onBlur={e => this._onBlurMontantFraisNotaire(e.target.value)}
                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'montantFraisNotaire', e, false, 2)}
                                deferredValidationTime={0}
                                suffix="€"
                                tabIndex="3"
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <DetailsList
                            className="containerReservation"
                            items={this.props.listeDesTVAs}
                            selectionMode={SelectionMode.single}
                            selection={this._selectionTVA}
                            columns={this.columnsListeTVA}
                            isHeaderVisible={false}
                            selectionPreservedOnEmptyClick
                        />
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <div className="zoneAide">Il est important de bien vérifier le montant HT et l'arrondi du montant TTC ainsi que le taux de TVA à appliquer. Ces éléments seront validés par Eiffage Immobilier.</div>
                    </div>
                </div>
            </div>
        );
    }

    constructor(props) {
        super(props);

        var _this = this;
        this._selectionTVA = new Selection({
            onSelectionChanged: () => {
                const selectionCount = _this._selectionTVA.getSelectedCount();

                if (selectionCount === 1) {
                    _this._calculPrixTTCSiChangementTVA((_this._selectionTVA.getSelection()[0]).taux, (_this._selectionTVA.getSelection()[0]).idTVACas);
                }
                else {
                    let reservation = { ...this.state.reservation };
                    reservation.idTVACas = null;
                    this.setState({ reservation: reservation }, this._onVerificationFormulaire);
                }
            }
        });

        let columnsTempListeTVA = [];

        columnsTempListeTVA.push({ key: 'idTVACas', name: '', fieldName: 'idTVACas', minWidth: 20, maxWidth: 20 });
        columnsTempListeTVA.push({ key: 'tvaCas', name: 'Cas TVA', fieldName: 'tvaCas', minWidth: 200, maxWidth: 200, isResizable: true });
        columnsTempListeTVA.push({ key: 'libelle', name: 'Libellé', fieldName: 'libelle' });
        columnsTempListeTVA.push({
            key: 'taux', name: 'Taux', fieldName: 'taux', minWidth: 50, maxWidth: 50,
            onRender: (item) => {
                return <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee((item.taux * 100).toFixed(2), false, 2)} %</span>;
            }
        });

        this.columnsListeTVA = columnsTempListeTVA;

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        let _this = this;

        let reservation = this.props.reservation;
        reservation.prixHT = parseFloat(this.props.reservation.prixHT);

        this.setState({
            reservation: reservation,

            titrePanelTarifReservation: 'Modifier les tarifs de la réservation',

            enCoursDeTraitement: false,
            messageEnCoursTraitement: ''
        }, function () {
            _this._preSelectionTVA(_this.props.listeDesTVAs, _this.props.reservation.idTVACas);
        });
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du tarif en cours'
        });

        let miseAJourReservation = DataReservation._miseAJourReservation(this.props.idOperation, this.props.idReservation, this.state.reservation);

        miseAJourReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'TarifReservation', this.state.reservation, (this.state.reservation.idReservation > 0 ? 'Modification' : 'Création'));
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <PrimaryButton onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!this.state.onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };


    _onFocusPrixHT() {
        Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'reservation', 'prixHT');
    }

    _onFocusPrixTTC() {
        Scriba.officeUI().textField().nombre().onFocusTextFieldNombre(this, 'prixTTC');
    }

    _onChangeFraisNotaireOffert = (fraisNotaireOffert) => {
        Scriba.state().setObjetPropriete(this, 'reservation', 'fraisNotaireOffert', fraisNotaireOffert, this._onVerificationFormulaire);

        if (this.props.onAffichageSansPanel) {
            this.props.onChange('fraisNotaireOffert', fraisNotaireOffert);
        }
    }
    _onChangeIdCasTVA = (idTVACas) => {
        Scriba.state().setObjetPropriete(this, 'reservation', 'idTVACas', idTVACas, this._onVerificationFormulaire);

        if (this.props.onAffichageSansPanel) {
            this.props.onChange('idTVACas', idTVACas);
        }
    }

    _onBlurMontantFraisNotaire = (montantFraisNotaire) => {
        Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'reservation', 'montantFraisNotaire', montantFraisNotaire.toString(), 'fr', this._onVerificationFormulaire);

        if (this.props.onAffichageSansPanel) {
            this.props.onChange('montantFraisNotaire', montantFraisNotaire !== "" ? montantFraisNotaire : null); // KP (2020/02/27) : correction erreur "Input string was not in a correct format" à la validation d'une résa
        }
    }
    _onBlurPrixHT(prixHT) {
        if (prixHT == null | prixHT == undefined)
            prixHT = 0;
        let prixTTC = parseFloat(parseFloat(prixHT) * (1 + parseFloat(this.state.reservation.tauxTVA)));
        prixTTC = prixTTC.toFixed(2);

        let _this = this;

        this.setState({ prixTTC: prixTTC },
            function () {//MAJ Props via appel OnChange du parent
                Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(_this, 'reservation', 'prixHT', prixHT, 'fr', this._onVerificationFormulaire)
                if (this.props.onAffichageSansPanel) {
                    this.props.onChange('prixHT', prixHT !== "" ? prixHT : null); // KP (2020/02/27) : correction erreur "Input string was not in a correct format" à la validation d'une résa
                }
            });
    }
    _onBlurPrixTTC(prixTTC) {
        if (prixTTC == null | prixTTC == undefined)
            prixTTC = 0;
        let prixHT = parseFloat(parseFloat(prixTTC) / (1 + parseFloat(this.state.reservation.tauxTVA)));
        prixHT = prixHT.toFixed(precision);

        let reservation = { ...this.state.reservation };
        reservation.prixHT = prixHT;

        let _this = this;

        this.setState({
            reservation: reservation
        },
            function () {//MAJ Props via appel OnChange du parent
                Scriba.officeUI().textField().nombre().onBlurTextFieldNombre(_this, 'prixTTC', prixTTC, 'fr', this._onVerificationFormulaire);
                if (this.props.onAffichageSansPanel) {
                    this.props.onChange('prixHT', prixHT !== "" ? prixHT : null); // KP (2020/02/27) : correction erreur "Input string was not in a correct format" à la validation d'une résa
                }
            });
    }

    _calculPrixTTCSiChangementTVA(taux, idTVACas) {
        let prixTTC = this.state.reservation.prixHT * (1 + parseFloat(taux));
        //prixTTC = prixTTC.toFixed(precision);

        // Modification de l’objet ou de la propriété
        let reservation = { ...this.state.reservation };
        if (this.state.prixTTC != prixTTC | reservation.idTVACas != idTVACas | reservation.tauxTVA != parseFloat(taux)) {
            reservation.idTVACas = idTVACas;
            reservation.tauxTVA = parseFloat(taux);

            // If you want a function to be executed after the state change occurs, pass it in as a callback
            let _this = this;

            this.setState({
                reservation: reservation,
                prixTTC: prixTTC,
                //idCasTVASelectionnee: idCasTVA
            }, function () {
                _this._onChangeIdCasTVA(idTVACas);
            });
        }
    }
    _preSelectionTVA(listeDesTVAs, idTVACas) {
        this._selectionTVA.setItems(listeDesTVAs, true);

        //AF - Ticket 1041
        let indexCasTVA = listeDesTVAs.findIndex(function (element) { return element.idTVACas === idTVACas; });
        this._selectionTVA.setIndexSelected((indexCasTVA), true, false);

        this._onVerificationFormulaire();
    }

    _onOpen = () => {
        if (!this.state.enCoursDeTraitement)
            this._chargementDonnees();
    }

    componentDidMount() {
        if (this.props.onAffichageSansPanel) {
            this._chargementDonnees();
        }
    }

    componentWillUnmount() { }

    componentDidUpdate() { }

    render() {
        let content = this._creationContent();

        if (this.props.onAffichageSansPanel) {
            return content;
        }
        else {
            return (
                <Panel
                    isOpen={this.props.onAffichePanelTarifReservation}
                    headerText={this.state.titrePanelTarifReservation}
                    type={PanelType.large}
                    onDismiss={() => this._onAnnulation()}
                    onOpen={() => this._onOpen()}
                    closeButtonAriaLabel="Fermer"
                    onRenderFooterContent={this._onRenderFooterContent}
                >
                    <div className={this.props.classname}>
                        <div className={this.props.classnameinner}>
                            <div className="ms-Grid" dir="ltr">
                                <MessageBars
                                    errorMessage={this.state.errorMessage}
                                    warningMessage={this.state.warningMessage}
                                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                                />

                                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                                {content}
                            </div>
                        </div>
                    </div>
                </Panel>
            );
        }
    }
}